// import { Link } from 'react-router-dom'
import React from 'react'
import ReservationSummary from './ReservationSummary'

const Main = () => {
  return (
    <>
        <main>
            {/* <Bradcom title={"Resumen de Reserva"} subtitle={"Inicio"} newtitle={"Resumen de Reserva"}/>         */}
            <ReservationSummary/>
        </main>
     
    </>
  )
}

export default Main